import './app/kernel';
import * as lightgallery from "./module/lightgallery";

document.addEventListener('DOMContentLoaded', () => {
  lightgallery.render('#catalog');
});
